<template>
  <div class="navigate-wrapper flex-row flex-spbt">
    <div
      v-for="(step, index) in this.title"
      :key="index"
      :class="`navigate-unit flex-row flex-center ${isOnStep(index)}`"
    >
      {{ `STEP${index + 1} - ${step}` }}
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'PaperNavigate',
  computed: {
    ...mapState('peerPaper', {
      stepNow: (state) => state.evaluationStep,
    }),
  },
  methods: {
    isOnStep(index) {
      return index + 1 === this.stepNow ? 'on-step' : '';
    },
  },
  data() {
    return {
      title:
        this.$i18n.locale === 'eng'
          ? [
              'Upload evaluation data',
              'Write evaluation sheet questions',
              'Save and send evaluation sheets',
            ]
          : ['평가 데이터 업로드', '평가지 질문 작성', '평가지 저장 및 전송'],
    };
  },
  watch: {
    '$i18n.locale': function (newLocale, oldLocale) {
      this.title =
        newLocale === 'eng'
          ? [
              'Upload evaluation data',
              'Write evaluation sheet questions',
              'Save and send evaluation sheets',
            ]
          : ['평가 데이터 업로드', '평가지 질문 작성', '평가지 저장 및 전송'];
    },
  },
};
</script>

<style lang="scss" scoped>
.navigate-wrapper {
  margin: 20px 10px;
}

.navigate-unit {
  width: 32%;
  height: 30px;
  border: 2px solid $MAIN-COLOR;
  border-radius: 5px;
}

.on-step {
  background: $MAIN-COLOR;
  color: white;
  font-weight: bold;
}
</style>
